module.exports = __webpack_public_path__ + "img/3.03571fef.jpg";